import { render, staticRenderFns } from "./FormAddANPR.vue?vue&type=template&id=1a6c8633"
import script from "./FormAddANPR.vue?vue&type=script&lang=js"
export * from "./FormAddANPR.vue?vue&type=script&lang=js"
import style0 from "./FormAddANPR.vue?vue&type=style&index=0&id=1a6c8633&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports